// BulkRowStatus may arrive as a string or its numeric enum value. The enum's existing
// values keep their order and the two newer ones (Updated, NoMatch) are appended, so a
// numeric status indexes straight into this array. Single source of truth for both the
// bulk modal and the wizard's file intake.
export const BULK_STATUS_LABELS = [
  'Pending',
  'Added',
  'Duplicate',
  'Invalid',
  'Failed',
  'Updated',
  'NoMatch',
];

export const bulkStatusLabel = (status) =>
  typeof status === 'number' ? BULK_STATUS_LABELS[status] || 'Pending' : status;
